/* eslint-disable react-refresh/only-export-components */

import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const alertVariants = cva('rounded-lg p-4 text-sm font-semibold', {
  variants: {
    variant: {
      destructive: 'border border-error-border bg-error-surface text-error-text',
      success: 'border border-success-border bg-success-surface text-success-text',
      warning: 'border border-warning-border bg-warning-surface text-warning-text',
      info: 'border border-border-brand bg-brand-50 text-brand-800',
      neutral: 'border border-border-subtle bg-muted text-text-primary',
    },
  },
  defaultVariants: {
    variant: 'destructive',
  },
});

export interface AlertProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertVariants> {}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  ({ className, variant, ...props }, ref) => (
    <div
      ref={ref}
      role="alert"
      className={cn(alertVariants({ variant, className }))}
      {...props}
    />
  )
);
Alert.displayName = 'Alert';

export { Alert, alertVariants };
